import { type QuestionType } from 'types/services/Family'
import { currentCourseRule } from 'utils/definitionRecomedationRules/educationRules'
import handleFinalInfoCardAdjustments from 'utils/handleFinalInfoCardAdjustments'

/*
  🔵 Adiciona aos dados os atributos: isAlert, inconsistent. Onde os 
  alertas são calculados no front e as inconsistencias vem do back
*/

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function cardsInfoEducation(member: any, base: string, inconsistencies: any) {
  const cardsInfos: QuestionType[] =
    Object.keys(member?.education).map((attribute: string) => {
      const memberName = member?.name?.replace(/ /g, '')?.toLowerCase() ?? ''
      return {
        ...member.education[attribute],
        inconsistent: inconsistencies?.childrenInconsistentFields?.[
          memberName
        ]?.includes(`education.${attribute}`),

        isAlert:
          attribute === 'currentCourse'
            ? currentCourseRule(member, base)
            : false,
      }
    }) ?? []

  // função que confirma que um card não será alerta se for inconsistente e depois ordena os alertas para primeiro
  return handleFinalInfoCardAdjustments(cardsInfos)
}

export default cardsInfoEducation
